import * as React from "react";
import { Button } from "@mandrac/ui";
import { useI18n } from "../lib/i18n";

function Fallback({ error }: { error: Error }) {
  const { t } = useI18n();
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-xl flex-col justify-center gap-4 p-6">
      <h1 className="m-0 text-28 font-extrabold">{t("error.boundary.title")}</h1>
      <p className="m-0 text-16 text-muted">{t("error.boundary.body")}</p>
      <div className="flex flex-wrap gap-2">
        <Button variant="accent" onClick={() => window.location.reload()}>
          {t("error.boundary.reload")}
        </Button>
        <Button variant="outline" onClick={() => (window.location.href = "/")}>
          {t("error.boundary.home")}
        </Button>
      </div>
      <details className="text-13 text-muted">
        <summary>{t("common.details")}</summary>
        <pre className="whitespace-pre-wrap">{error.message}</pre>
      </details>
    </main>
  );
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(JSON.stringify({ level: "error", msg: "ui.error", error: error.message, stack: info.componentStack }));
  }
  override render() {
    return this.state.error ? <Fallback error={this.state.error} /> : this.props.children;
  }
}
